"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateIsNeededForScaledAccuracy = updateIsNeededForScaledAccuracy;
/**
 * Use the scale of the existing value of a count to determine when to update that count
 *
 * This is a function that takes an existing count and decides whether it should be updated, based on the scale of that
 * existing count. It tries to maintain a probabilistic accuracy of some constant percentage of the figure.
 *
 * This is particularly appropriate for numbers that are generally incremented/decremented and don't often change in
 * magnitude immediately, such as the number of projects belonging to an account. We'll also usually be displaying large
 * counts with less precision (e.g. we may round to a few significant figures).
 *
 * Another advantage of this approach is that it avoids any need for persistence around when we last updated the count
 *
 * @param probabilisticAccuracyTarget - Is a fraction, representing the desired probabilistic accuracy of the count, by default 0.1%
 * @param existingCount - The existing count that we are considering whether to update
 *
 * For example, if probabilisticAccuracyTarget is 1/1000 (0.1%), then:
 *  - If the existing count is less than 1000, we update the count every time
 *  - If the existing count is 2000, we only update it on 50% of document changes on average
 *  - If the existing count is 10,000, we only update it on 10% of document changes on average
 *  - If the existing count is 100,000, we only update it on 1% of document changes on average
 *  - If the existing count is 1,000,000, we only update it on 0.1% of document changes on average
 * And this means that if the number is changing via increments/decrements, and we attempt to update the number on each
 * increment/decrement, we should be within 1/1000th of the true value, almost always (modulo probabilistic variation).
 */
function updateIsNeededForScaledAccuracy(existingCount, probabilisticAccuracyTarget = 1 / 1000) {
    if (existingCount <= 0) {
        return true;
    }
    return Math.random() < 1 / (existingCount * probabilisticAccuracyTarget);
}
//# sourceMappingURL=count.js.map